import { groupBy } from 'widget/helpers/utils';
import { groupConversationBySender } from './helpers';
import { formatUnixDate } from 'shared/helpers/DateHelper';

export const getters = {
  getAllMessagesLoaded: _state => _state.uiFlags.allMessagesLoaded,
  getIsFetchingConversationList: _state =>
    _state.uiFlags.isFetchingConversationList,
  getHasLoadedConversations: _state => _state.uiFlags.hasLoadedConversations,
  getIsCreating: _state => _state.uiFlags.isCreating,
  getIsAgentTyping: _state => _state.uiFlags.isAgentTyping,
  getHasAudioPermissionIssue: _state => _state.uiFlags.hasAudioPermissionIssue,
  getConversation: _state => _state.conversations,
  getAllConversations: _state => _state.allConversations,
  getAllConversationsSize: _state => _state.allConversations.length,
  getConversationSize: _state => {
    const conversations = JSON.parse(JSON.stringify(_state.conversations));
    delete conversations[0];
    const size = Object.keys(conversations).reduce((acc, id) => {
      const msg = conversations[id];
      return acc + (msg.is_greeting_message ? 0 : 1);
    }, 0);
    return size;
  },
  getEarliestMessage: _state => {
    const conversation = Object.values(_state.conversations);
    if (conversation.length) {
      return conversation[0];
    }
    return {};
  },
  getGroupedConversation: _state => {
    /**
     * Re order bot greeting message
     */
    let conversations = Object.values(_state.conversations);

    if (window.hooryWebChannel && window.hooryWebChannel.greetingEnabled) {
      const index = conversations.findIndex(
        ({ content, message_type }) =>
          content === window.hooryWebChannel.greetingMessage &&
          message_type === 3
      );

      if (index) {
        const temp = conversations[index];

        conversations[index] = conversations[index - 1];

        conversations[index - 1] = temp;
      }
    }

    const conversationGroupedByDate = groupBy(conversations, message =>
      formatUnixDate(message.created_at)
    );

    return Object.keys(conversationGroupedByDate).map(date => ({
      date,
      messages: groupConversationBySender(conversationGroupedByDate[date]),
    }));
  },
  getIsFetchingList: _state => _state.uiFlags.isFetchingList,
  getIsFetchingMessages: _state => _state.uiFlags.isFetchingMessages,
  getMessageCount: _state => {
    return Object.values(_state.conversations).length;
  },
  getUnReadConversationsCount: _state => {
    return Object.values(_state.allConversations).filter(
      chat => !!chat.unread_count
    ).length;
  },
  getUnreadMessageCount: _state => {
    let unreadCount = 0;
    if (!_state.allConversations) return 0;

    _state.allConversations.forEach(chat => {
      unreadCount += chat.unread_count;
    });
    return unreadCount;
  },
  getLastUnreadConversation: _state => {
    return _state.allConversations.find(chat => chat.unread_count > 0);
  },
  getLastConversation: _state => {
    return _state.allConversations[0];
  },
  getUnreadTextMessages: _state => {
    if (!_state.allConversations) return 0;

    const unreadConversations = _state.allConversations.filter(
      conversation => conversation.unread_count > 0
    );

    if (unreadConversations.length === 0) return [];
    return [unreadConversations[0].last_message];
  },
};
